import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "ccs_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 28 }}
          className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-[60]"
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Consimțământ cookie-uri"
        >
          <div className="bg-ink text-cream shadow-2xl border border-cream/10 p-6 md:p-7">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-9 w-9 grid place-items-center bg-cream/10 text-sand shrink-0">
                <Cookie size={18} />
              </span>
              <p className="font-display text-2xl leading-none">Cookie-uri</p>
            </div>
            <p className="text-cream/70 text-sm leading-relaxed">
              Folosim cookie-uri pentru a asigura funcționarea magazinului și pentru a-ți
              îmbunătăți experiența. Poți afla mai multe în{" "}
              <Link to="/cookies" className="text-sand underline hover:no-underline" data-testid="cookie-policy-link">
                Politica de cookies
              </Link>
              .
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-6">
              <button
                onClick={() => decide("all")}
                data-testid="cookie-accept-all"
                className="flex-1 bg-cream text-ink px-5 py-3 text-sm font-semibold tracking-wide hover:bg-sand transition-colors"
              >
                Accept toate
              </button>
              <button
                onClick={() => decide("essential")}
                data-testid="cookie-essential-only"
                className="flex-1 border border-cream/25 text-cream px-5 py-3 text-sm font-semibold tracking-wide hover:border-cream/60 transition-colors"
              >
                Doar necesare
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
